module.exports = __webpack_public_path__ + "img/Hunter-tauren-m-60.16fa0e31.gif";